<div class="modal-header">
  <h3 class="modal-title">Actualizar {{alertName}}</h3>
  <button type="button" class="close text-primary" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<form (ngSubmit)="submitForm()">
  <div class="modal-body">
    <div class="form-group">
      <label for="" class="text-form"> Actividad </label>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-2 pl-3 pr-1">
          <label for="" class="text-form"> Asunto: </label>
        </div>
        <div class="col-md-6 pl-0 pr-0">
          <p class="text-title">{{actvName}}</p>
        </div>
        <div class="col-sm-1">
          <label for="" class="text-form"> Fecha: </label>
        </div>
        <div class="col-md-3">
          <p class="text-title">{{dateActv}}</p>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="" class="text-form"> {{alertName}} </label>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <label for="" class="text-form">Fecha:</label>
        </div>
        <div class="col-md-6">
          <label for="" class="text-form">Hora:</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 date-activity">
          <div class="input-group">
            <input
              class="form-control style-datepicker"
              placeholder="Seleccionar fecha"
              name="Fecha_Actividad" [(ngModel)]="model1"
              #Fecha_Actividad="ngModel"
              ngbDatepicker #d1="ngbDatepicker"
              [minDate]="mindate"
              [maxDate]="maxdate"
              [readonly]="true"
              [placement]="'bottom-left'"
              >
            <div class="input-group-append style-button">
              <button class="btn fas fa-calendar-alt bt" (click)="d1.toggle()" type="button"></button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <ngb-timepicker
            [(ngModel)]="timeAlert"
            [meridian]="meridian"
            class="time-picker"
            name="time_actv"
            >
          </ngb-timepicker>
        </div>
      </div>
      <!-- Message Success  new Alert -->
      @if (successMessageNewAlert) {
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <ngb-alert class="mt-3" type="success" (close)="successMessageNewAlert = ''">{{ successMessageNewAlert }}</ngb-alert>
            </div>
          </div>
        </div>
      }
      <!-- Message Error new Alert -->
      @if (errorMessageNewAlert) {
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <ngb-alert  class="mt-3" type="danger" (close)="errorMessageNewAlert = ''">{{ errorMessageNewAlert }}</ngb-alert>
            </div>
          </div>
        </div>
      }
      <!-- <pre>Selected time: {{time | json}}</pre> -->
    </div>
  </div>
  <div class="modal-footer">
    <div class="form-group">
      <div class="row">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
            (click)="activeModal.close('Close click')">
            Cerrar
          </button>
          <button type="submit"
            class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold mr-2"
            style="width: 120px;"
            >
            @if (loading) {
              <div>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Cargando...
              </div>
            }
            @if (!loading) {
              <span>
                Actualizar
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>
</form>


